import { ReactNode, useState, SyntheticEvent } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { GameRequirements } from './OperatingSystemRequirementsList';
import { useMobile } from 'src/hooks/useMobile';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`requirements-tabpanel-${index}`}
      aria-labelledby={`requirements-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography variant="subtitle1">{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `requirements-tab-${index}`,
    'aria-controls': `requirements-tabpanel-${index}`,
  };
}

export function RequirementTabs({
  minimumRequirements,
  recommendedRequirements,
}: GameRequirements) {
  const sortedMinKeys = Object.keys(minimumRequirements).sort();
  const sortedRecKeys = Object.keys(recommendedRequirements).sort();
  const [value, setValue] = useState(0);
  const match = useMediaQuery('(max-width: 470px)');
  const isMobile = useMobile();
  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: !match ? '100%' : '300px' }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          variant={'scrollable'}
          scrollButtons={false}
          sx={{
            marginBottom: '38px',
            borderBottom: '2px solid #4DC8FF',
            background: '#001B3BCC',
            borderRadius: '10px 10px 0px 0px',
            '& .Mui-selected': {
              borderRadius: '10px 10px 0px 0px',
              color: '#ffffff',
              background: '#80B7FF29',
              padding: '8px 64px',
            },
            '& .MuiTabs-indicator': {
              background: 'unset ',
            },
            ...(isMobile && { button: { width: '200px' } }),
          }}
        >
          <Tab
            sx={{
              width: '234px',
              height: '58px',
              fontSize: '16px',
              fontWeight: '600',
              color: '#ffffff',
            }}
            label="MINIMUM"
            {...a11yProps(0)}
          />
          <Tab
            sx={{
              width: '250px',
              height: '58px',
              fontSize: '16px',
              color: '#ffffff',
              fontWeight: '600',
            }}
            label="RECOMMENDED"
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>

      <Stack direction="column" spacing="5px">
        {sortedMinKeys.map((key) => (
          <TabPanel key={key} value={value} index={0}>
            {minimumRequirements[`${key}`]}
          </TabPanel>
        ))}
      </Stack>

      <Stack direction="column" spacing="5px">
        {sortedRecKeys.map((key) => (
          <TabPanel key={key} value={value} index={1}>
            {recommendedRequirements[`${key}`]}
          </TabPanel>
        ))}
      </Stack>
    </Box>
  );
}
